import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LoginComponent } from './login/login.component'
import { SignupComponent } from './signup/signup.component'
import { DropOffComponent } from './drop-off/drop-off.component'
import { LoggedInGuardService } from './logged-in-guard.service'

const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [LoggedInGuardService]},
  { path: 'signup', component: SignupComponent},
  { path: 'authenticate', component: DropOffComponent},
  { path: '', redirectTo: 'login', pathMatch: 'full' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
